import React, { Component } from "react";
import Chart from "react-google-charts";

export default class Responsive extends Component {
  state = {
    on: true,
    miners: [
      ["Regions", "Nodes"],
      ["Null", 1],
      ["Seoul", 0],
      ["Busan", 0],
      ["Daegu", 0],
      ["Gyeonggi", 0],
      ["Gyeongnam", 0],
      ["Gyeongbuk", 0],
      ["Ulsan", 0],
      ["Jeonbuk", 0],
      ["Jeonnam", 0],
      ["Gwangju", 0],
      ["Chungbuk", 0],
      ["Chungnam", 0],
      ["Daejeon", 0],
      ["Gangwon", 0],
      ["Jeju", 0],
      ["Incheon", 0],
    ],
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data && nextProps.data !== prevState.miners) {
      let data = [["Regions", "Nodes"]];
      Object.keys(nextProps.data).map((region) => {
        data.push([region, nextProps.data[region]]);
      });
      return { miners: data };
    }
    return null;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <Chart
        width={"100%"}
        height={"100%"}
        chartType="GeoChart"
        data={[...this.state.miners]}
        options={{
          region: "KR",
          resolution: "provinces",
        }}
        // Note: you will need to get a mapsApiKey for your project.
        // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
        mapsApiKey="AIzaSyAQr0DyQQ892DXK-fJriyQjamjNwlipKNU"
        rootProps={{ "data-testid": "1" }}
      />
    );
  }
}
